export var CmpDisplayStatus;
(function (CmpDisplayStatus) {
    CmpDisplayStatus["VISIBLE"] = "visible";
    CmpDisplayStatus["HIDDEN"] = "hidden";
    CmpDisplayStatus["DISABLED"] = "disabled";
})(CmpDisplayStatus || (CmpDisplayStatus = {}));
